import React, { useEffect, useState } from "react";
import { captureRefFromUrl } from "../pages/public/partnerRef";

const API = process.env.REACT_APP_BACKEND_URL;
const cache = new Map();

/** Slim "Shared by {Realtor}, {Brokerage}" strip for pages opened from a realtor's ?ref= link.
 * Reuses the partner's public profile (headshot, brokerage) — nothing new for the realtor to fill in. */
export function SharedByStrip({ dark = false }) {
  const [partner, setPartner] = useState(null);
  useEffect(() => {
    const slug = captureRefFromUrl();
    if (!slug) return undefined;
    let cancelled = false;
    const apply = (p) => { if (!cancelled) setPartner(p); };
    if (cache.has(slug)) { apply(cache.get(slug)); return undefined; }
    fetch(`${API}/api/public/partners/${encodeURIComponent(slug)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => { cache.set(slug, p); apply(p); })
      .catch(() => apply(null));
    return () => { cancelled = true; };
  }, []);
  if (!partner?.name) return null;
  const initials = partner.name.split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();
  const bg = dark ? "bg-[#0B101E] text-white/80 border-white/10" : "bg-[#FAFAF7] text-[#1A1A1A]/80 border-black/10";
  return (
    <div className={`w-full border-b ${bg}`} data-testid="shared-by-strip">
      <div className="max-w-7xl mx-auto px-5 md:px-12 py-2 flex items-center gap-3 text-[13px]">
        <span className="h-7 w-7 rounded-full overflow-hidden shrink-0 bg-black/10 flex items-center justify-center text-[11px] font-semibold" aria-hidden="true">
          {partner.photo_url
            ? <img src={partner.photo_url} alt="" className="h-full w-full object-cover" style={{ objectPosition: `${partner.photo_pos_x ?? 50}% ${partner.photo_pos_y ?? 50}%` }} />
            : initials}
        </span>
        <span className="truncate">
          <span className="uppercase tracking-[0.18em] text-[10px] opacity-70 mr-2">Shared by</span>
          <span className="font-medium" data-testid="shared-by-name">{partner.name}</span>
          {partner.brokerage && <span className="opacity-70">, {partner.brokerage}</span>}
        </span>
      </div>
    </div>
  );
}
